import { render, staticRenderFns } from "./bodegas-chacra.vue?vue&type=template&id=5ef57eca&scoped=true"
import script from "./bodegas-chacra.vue?vue&type=script&lang=js"
export * from "./bodegas-chacra.vue?vue&type=script&lang=js"
import style0 from "./bodegas-chacra.vue?vue&type=style&index=0&id=5ef57eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef57eca",
  null
  
)

export default component.exports